import { App, Plugin } from 'vue';
import directive from './directive';

export default <Plugin>{
  install(app: App) {
    app.directive('bt-tooltips', directive);
  },
};
